import React from "react";
import DotsHorizontalIcon from "mdi-react/DotsHorizontalIcon";
import { Menu, MenuItem, Popover } from "@blueprintjs/core";

const MoreActions = (props) => {
  const optionsMenu = (
    <Menu>
      <MenuItem
        onClick={() =>
          props.deleteItem ? props.deleteItem(props.item) : undefined
        }
        text="Delete"
      />
    </Menu>
  );
  return (
    <div>
      <div className="more-details-ellipsis-container">
        <Popover content={optionsMenu} position="bottom">
          <DotsHorizontalIcon item={props.item} />
        </Popover>
      </div>
    </div>
  );
};

export default MoreActions;
